module.exports = __webpack_public_path__ + "f6b01aa9b898863f36046ffe1495b00e.pdf";